<template>
  <div>
    <div class="iDalgo-Player-Search" v-loading="loading">
      <div class="iDalgo-Player-Search__Filter">
        <p class="title">{{ $t('iDalgoListEdit.searchPlayers.filter') }}</p>
        <i-dalgo-select-dropdown class="iDalgo-Player-Search__Filter__Dropdown" v-bind:choices="choices" v-bind:filter="filter"></i-dalgo-select-dropdown>
        <el-input v-model="search" :placeholder="$t('iDalgoListEdit.searchPlayers.placeholders.player')" />
      </div>
      <div class="iDalgo-Player-Search__List" v-infinite-scroll="loadMore" ref="player_list">
        <draggable
          :value="draggableList"
          :options="{group:'players', forceFallback: true, handle: '.iDalgo-Player-Item', draggable: '.iDalgo-Player-Item'}"
          @start="handleDraggableStart"
          @end="handleDraggableEnd"
          :move="handleDraggableMove">
          <transition-group name="fade">
            <i-dalgo-player-item v-for="(player, key) in draggableList" :key="`player-${key}`" :player="player" />
          </transition-group>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import iDalgoPlayerItem from '@/components/iDalgo-Player-Item'
import iDalgoButton from '@/components/iDalgo-Button'
import iDalgoSelectDropdown from '@/components/iDalgo-Select-Dropdown'
import draggable from 'vuedraggable'
import { debounce } from 'lodash'
import Sticky from '@/services/sticky.js'

export default {
  name: 'iDalgo-Player-Search',
  components: {
    iDalgoSelectDropdown,
    iDalgoPlayerItem,
    draggable,
    iDalgoButton
  },
  props: {},
  computed: {
    ...mapGetters({
      players: 'players/players',
      loading: 'players/isLoading',
      listPlayers: 'templates/listPlayers',
      pagination: 'players/pagination',
      dragging: 'players/dragging'
    }),
    filter: {
      get: ctx => ctx.$store.getters['players/filter'],
      set: (ctx, value) => ctx.$store.commit('players/FILTER_UPDATED', value)
    },
    search: {
      get () { return this.$store.getters['players/search'] },
      set (value) { this.$store.commit('players/SEARCH_UPDATED', value) }
    },
    draggableList: {
      get () {
        return this.players.filter(player => {
          return !this.listPlayers.filter(p => parseInt(player.id) === parseInt(p.id)).length
        })
      },
      set (players) {
        this.$store.commit('players/PLAYERS_UPDATED', players)
      }
    }
  },
  data () {
    return {
      choices: [
        {
          title: this.$t('iDalgoListEdit.searchPlayers.filters.player'),
          filter: 'name'
        },
        {
          title: this.$t('iDalgoListEdit.searchPlayers.filters.club'),
          filter: 'club'
        }
        // {
        //   title: this.$t('iDalgoListEdit.searchPlayers.filters.country'),
        //   filter: 'country'
        // }
      ],
      animation: null
    }
  },
  methods: {
    labelSelection ({ tName, tFirstName, tNickName }) {
      if (tName === tNickName) {
        return `${tFirstName} ${tName}`
      }
      return tNickName
    },
    handleDraggableMove (evt) {
      // prevent order in selection list
      document.querySelectorAll('.iDalgo-Section__Content').forEach((el) => {
        el.classList.remove('dragzone')
      })
      evt.to.offsetParent.classList.add('dragzone')
      return (evt.to.offsetParent.classList[0] !== 'iDalgo-Player-Search__List')
    },
    handleDraggableStart () {
      this.$store.commit('players/DRAGGING_UPDATED', true)
    },
    handleDraggableEnd () {
      document.querySelectorAll('.dragzone').forEach((el) => {
        el.classList.remove('dragzone')
      })
      this.$store.commit('players/DRAGGING_UPDATED', false)
    },
    loadMore () {
      this.$store.dispatch('players/getPlayers', this.pagination.currentPage + (this.players.length ? 1 : 0))
    },
    debouncedSearch: debounce((ctx) => {
      ctx.$store.dispatch('players/searchPlayers', ctx.$refs.player_list)
    }, 400)
  },
  watch: {
    search (query) {
      // Debounce player research for performances
      this.debouncedSearch(this, query)
    },
    choices (val) {
      this.$store.dispatch('players/searchPlayers', this.$refs.player_list)
    }
  },
  mounted () {
    // Animate search on scroll
    this.animation = new Sticky(this.$el)
  },
  beforeDestroy () {
    // kill animation on scroll for perf
    this.animation.die()
    // Pagination reset
    this.$store.commit('players/PAGINATION_UPDATED', 1)
    // Page scroll top reset
    this.$el.querySelector('.iDalgo-Player-Search__List').scrollTop = 0
  }
}
</script>

<style lang="scss">

.iDalgo-Player-Search {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  user-select: none;

  &__Filter, &__List {
    background-color: $white;
  }

  &__Filter {
    margin-bottom: 5px;
    padding: 20px 15px;

    .title {
      color: $color1;
      font-size: 20px;
      margin: 0px;
    }

    &__Dropdown {
      margin: 20px 0px 5px 0px;
    }

    .el-input__inner {
      font-size: 14px;
    }
  }

  &__List {
    overflow-x: hidden;
    background: $white;
    padding: $default_padding;
    height: calc(100vh - 500px);

    & > div & span {
      padding: 4px;
    }

    &::-webkit-scrollbar {
      width: 7px;
      background-color: $medium-gray;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $color1;
      height: 34px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Player-Search.vue